export default __webpack_public_path__ + "static/media/49.b9121522.jpg";